var map = {
	"./ams1.svg": "b797",
	"./ams2.svg": "d5d2",
	"./ams3.svg": "3371",
	"./blr1.svg": "1de7",
	"./fra1.svg": "c805",
	"./lon1.svg": "341c",
	"./nyc1.svg": "594c",
	"./nyc2.svg": "4249",
	"./nyc3.svg": "c7b8",
	"./sfo1.svg": "ac6c",
	"./sfo2.svg": "1374",
	"./sgp1.svg": "9654",
	"./syd1.svg": "4bfe",
	"./tor1.svg": "2680"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c0f2";